'use strict';
import React from 'react';
import flux from 'utils/flux';
import store from 'store';
import { Link, RouteHandler } from 'react-router';
import isEmpty from 'lodash/lang/isEmpty';
import classnames from 'classnames';
import AltContainer from 'alt-container';
import MediaFilters from 'pages/media/mediaFilters';
import AltFilters from 'pages/media/altFilters';
import MediaSelectedFilters from 'pages/media/mediaSelectedFilters';
import PartnerLinks from 'components/links/partnerLinks';
import HeaderLayout from 'components/headerBar/HeaderLayout';
import HeaderPagination from 'components/headerBar/headerPagination';
import HeaderSelection from 'components/headerBar/headerSelection';
import HeaderSearch from 'components/headerBar/headerSearch';
import HeaderSorting from 'components/headerBar/headerSorting';

import FooterBar from 'components/footerBar/footerBar';

var MediaPage = React.createClass({
    displayName: 'MediaPage',
    contextTypes: {
        router: React.PropTypes.func.isRequired
    },
    statics: {
        willTransitionTo: function (transition) {
            if (!flux.getStore('app').isAuthenticated()) {
                transition.redirect('/login', {}, { nextPath: transition.path });
            }
            if (!flux.getStore('app').hasAcceptedLatestTerms()) {
                transition.redirect('/accept_terms', {}, { nextPath: transition.path });
            }
        }
    },
    componentWillMount() {
        this.checkProps(this.props);
    },

    componentWillReceiveProps(nextProps) {
        this.checkProps(nextProps);
        if (this.props.query != nextProps.query) {
            window.scrollTo(0, 0);
        }
    },

    checkProps(props) {
        let query = props.query;
        const { defaultPerPageResults } = flux.getStore('app').getState().config.toJS();
        const { router } = this.context;
        const route = router.getRouteAtDepth(1);
        const isLanding = route && 'landing-page' === route.name;
        if (!isLanding) {
            let sortingKeyFromStore = sessionStorage.getItem('sortingKey');
            if (!query.sorting && sortingKeyFromStore && this.checkIfSortingKeyIsValid(sortingKeyFromStore)) {
                query.sorting = sortingKeyFromStore;
                this.context.router.transitionTo('listing', null, query);
            }
        }
        if (!props.query.per_page) {
            props.query["per_page"] = store.get('pagination_amount') || defaultPerPageResults;
        }
        flux.getStore('media').loadMedia( props.query );
    },

    // check if sortingkey used is still valid from search_settings
    checkIfSortingKeyIsValid(sortingKey) {
        let validity = false;
        config.searchSortSettings.map((index) => {
            if (index === sortingKey) {
                validity = true;
            }
        });
        return validity;
    },

    renderBackToHome() {
        const { router } = this.context;
        const route = router.getRouteAtDepth(1);
        const isLanding = route && 'landing-page' === route.name;
        if (!isLanding )  {
            return (
                <Link to="landing-page" onClick={this.clearFilters} className="sidebar__back">
                    <i className={(this.state.searchFilter ? "chevron-left" : "home")}/>
                    {flux.t('back_to_home')}
                </Link>
            );
        }
    },

    clearFilters(e) {
        e.preventDefault();
        flux.getActions('media').clearQuery();
        this.context.router.transitionTo('landing-page');
    },

    getInitialState() {
        return {
            searchFilter: true
        };
    },

    toggleFiltersWidth(e) {
        e.preventDefault();
        this.setState({
            searchFilter: !this.state.searchFilter
        })
    },

    render() {
        return (
            <AltContainer
                stores={ { mediaStore: flux.getStore('media'), basketStore: flux.getStore('basket') } }
                render={ (props) => {
                    const loading = this.props.flux.stores.media.isLoading();
                    const { layoutSwitch } = this.props.flux.stores.app.getState().config.toJS();
                    const { page } = this.props.query;
                    const showPagination = !loading || (loading && page);
                    const searchableFilterActive = window.config.searchableFilterActive;
                    const searchableFilterHeight = window.config.searchableFilterHeight;
                    const hideFilterOnLanding = window.config.hideFilterOnLanding || false;
                    const limitNoOfFilters = window.config.limitNoOfFilters > 0 ? true : false;
                    const numberOfFilters = window.config.limitNoOfFilters;
                    const { router } = this.context;
                    const route = router.getRouteAtDepth(1);
                    const isLanding = route && 'landing-page' === route.name;
                    return (
                        <div className={classnames('page', 'media', isLanding ? 'landing' : null)}>
                            <div className="headerbar">
                                  <div className="headerbar--media">
                                      <HeaderSearch query={props.mediaStore.params.search }/>
                                      <HeaderSelection media={props.mediaStore.media} />
                                      {showPagination && <HeaderPagination pagination={props.mediaStore.meta} />}
                                      {(showPagination && !isLanding) && <HeaderLayout />}
                                      {(showPagination  && !isLanding) &&  < HeaderSorting />}
                                  </div>
                            </div>

                            <div className="media__container">
                                {!(hideFilterOnLanding && isLanding) && <div
                                    className={ "container__filters" + (this.state.searchFilter ? " search-filter-opened" : " search-filter-colapsed") }>
                                    <MediaSelectedFilters size={ props.mediaStore.media.size }
                                                          filters={ props.mediaStore.selectedFilters }
                                                          query={ this.props.query }/>
                                    { searchableFilterActive ?
                                        <AltFilters selectedFilters={ props.mediaStore.selectedFilters }
                                                    filters={ props.mediaStore.filters }
                                                    isExpanded={ props.mediaStore.isExpanded }
                                                    filterHeight={ searchableFilterHeight }
                                                    limitNoOfFilters={ limitNoOfFilters }
                                                    numberOfFilters={ numberOfFilters }/>
                                        : <MediaFilters filters={ props.mediaStore.filters }
                                                        isExpanded={ props.mediaStore.isExpanded }>
                                            <button onClick={ this.toggleFiltersWidth } className="hamburger-arrow">
                                                <span className="line"></span>
                                                <span className="line"></span>
                                                <span className="line"></span>
                                            </button>
                                        </MediaFilters> }
                                    <div className="partner-links">
                                        <PartnerLinks/>
                                    </div>
                                    { this.renderBackToHome() }
                                </div>}
                                <div className="container__content">
                                    <RouteHandler { ...this.props } mediaStore={ props.mediaStore }  basketStore={props.basketStore}/>
                                </div>
                            </div>
                        </div>
                    );
                } }>
            </AltContainer>
        );
    }
});

module.exports = MediaPage;



// WEBPACK FOOTER //
// ./app/pages/media/index.jsx